import { render } from "./ShiftAresGlobalParameters.vue?vue&type=template&id=2d6b0e68&ts=true"
import script from "./ShiftAresGlobalParameters.vue?vue&type=script&lang=ts"
export * from "./ShiftAresGlobalParameters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__